import { Helmet } from "react-helmet-async";
import { LANGS, X_DEFAULT_PATH } from "@/lib/i18n-langs";
import { SITE_URL } from "@/lib/seo-jsonld";

/**
 * Inject hreflang alternate links for the multilingual landing pages.
 * Use on the FR homepage and on each /{lang} landing page so Google can map equivalents.
 *
 * Pages without a translated equivalent (other than the FR landing) do NOT need hreflang —
 * adding mismatched alternates would be a spec violation.
 */
const HreflangTags = () => (
  <Helmet>
    {LANGS.map((l) => (
      <link
        key={l.hreflang}
        rel="alternate"
        hrefLang={l.hreflang}
        href={`${SITE_URL}${l.path}`}
      />
    ))}
    <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${X_DEFAULT_PATH}`} />
  </Helmet>
);

export default HreflangTags;
